import AbstractView from "abstracts/AbstractView";
import Scroll from "controllers/Scroll";


export default class AgencyAwards extends AbstractView {
	constructor( $wrapper ) {
		super();
		this.$wrapper = $wrapper;
		this.isOpen   = false;
		this.init();
	}
	
	
	initDOM() {
		this.$mask   = this.$wrapper.find( '.agency-awards_list-mask' );
		this.$inner  = this.$wrapper.find( '.agency-awards_list-inner' );
		this.$button = this.$wrapper.find( '.agency-awards_more' );
	}
	
	
	bindEvents() {
		this.onMoreClickHandler = this.onMoreClick.bind( this );
		this.$button.on( 'click', this.onMoreClickHandler );
	}
	
	
	unbindEvents() {
		this.$button.off( 'click', this.onMoreClickHandler );
		super.unbindEvents();
	}
	
	
	onMoreClick() {
		if ( this.isOpen ) {
			return;
		}
		
		gsap.to( this.$mask, {
			duration:   0.6,
			height:     'auto',
			ease:       'power3.inOut',
			onComplete: () => {
				Scroll.resize();
			}
		} );
		this.$wrapper.addClass( 'open' );
		this.$wrapper.trigger( "open" );
		
	}
	
	
}
